import React, { useState } from 'react';
import { CalculatorIcon } from 'lucide-react';
import { useInventoryContext } from '../contexts/InventoryContext';
import { FinancingSimulator } from './FinancingSimulator';
import { FormField } from './FormField';
import { VehicleSelect } from './VehicleSelect';
interface FinancingPickerProps {
  onClose: () => void;
}
export function FinancingPicker({
  onClose
}: FinancingPickerProps) {
  const {
    cars
  } = useInventoryContext();
  const [carId, setCarId] = useState('');
  const car = cars.find(c => c.id === carId);
  return <div className="space-y-6" data-id="element-234" data-mp="2mngqe74zbcon">
      <FormField label="¿Qué vehículo querés financiar?" htmlFor="fp-car" data-id="element-235" data-mp="28q1v4ls1oaor">
        <VehicleSelect id="fp-car" value={carId} onChange={setCarId} placeholder="Elegí un vehículo" data-id="element-236" data-mp="28s4jz2hgnxrw" />
      </FormField>
      {car ? <FinancingSimulator key={car.id} car={car} onClose={onClose} data-id="element-237" data-mp="xad9pyufvjq2" /> : <div className="flex flex-col items-center rounded-xl border border-dashed border-line py-10 text-center" data-id="element-238" data-mp="11byk9dji3lx3">
          <CalculatorIcon className="h-8 w-8 text-muted" aria-hidden="true" data-id="element-239" data-mp="2mbdp0rf82pcm" />
          <p className="mt-3 text-sm text-muted" data-id="element-240" data-mp="2hdc5k5dvwo0m">Elegí un vehículo para ver anticipo y cuotas.</p>
        </div>}
    </div>;
}